(function () {
  "use strict";

  /* ---------- Utilities ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) { return r.json(); });
  }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function trapFocus(container) {
    var focusable = qsa('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (!focusable.length) return;
    focusable[0].focus();
  }

  if (!window.Shopify) window.Shopify = {};
  window.Shopify.formatMoney = window.Shopify.formatMoney || function (cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || "₹{{amount}}").replace("{{amount}}", value);
  };

  /* ---------- Reduced motion ---------- */
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.documentElement.classList.add("no-animations");
  }

  /* ---------- Scroll reveal ---------- */
  function initScrollReveal() {
    var items = qsa("[data-reveal]");
    if (!items.length) return;
    if (!("IntersectionObserver" in window) || document.documentElement.classList.contains("no-animations")) {
      items.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var nav = qs("[data-mobile-nav]");
    if (!nav) return;
    var openers = qsa("[data-mobile-nav-open]");
    var closers = qsa("[data-mobile-nav-close]", nav);

    openers.forEach(function (btn) {
      btn.addEventListener("click", function () {
        nav.setAttribute("data-open", "true");
        document.body.style.overflow = "hidden";
      });
    });
    closers.forEach(function (btn) {
      btn.addEventListener("click", closeNav);
    });
    qs(".mobile-nav__overlay", nav).addEventListener("click", closeNav);
    function closeNav() {
      nav.setAttribute("data-open", "false");
      document.body.style.overflow = "";
    }

    qsa("[data-mobile-sub-toggle]", nav).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest("[data-mobile-nav-item]");
        var expanded = item.getAttribute("data-expanded") === "true";
        item.setAttribute("data-expanded", expanded ? "false" : "true");
        btn.setAttribute("aria-expanded", expanded ? "false" : "true");
      });
    });
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    var panel = qs("[data-search-panel]");
    if (!panel) return;
    var input = qs("[data-search-input]", panel);
    var results = qs("[data-search-results]", panel);

    qsa("[data-search-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        panel.setAttribute("data-open", "true");
        setTimeout(function () { input.focus(); }, 50);
      });
    });
    qsa("[data-search-close]", panel).forEach(function (btn) {
      btn.addEventListener("click", closeSearch);
    });
    qs(".predictive-search__overlay", panel).addEventListener("click", closeSearch);
    function closeSearch() { panel.setAttribute("data-open", "false"); }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeSearch();
    });

    input.addEventListener("input", debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) { results.innerHTML = ""; return; }
      fetchJSON("/search/suggest.json?q=" + encodeURIComponent(term) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=show")
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            results.innerHTML = '<p style="color:var(--color-text-muted);padding:1rem 0;">No products found for "' + escapeHtml(term) + '"</p>';
            return;
          }
          results.innerHTML = products.map(function (p) {
            return '<a class="predictive-search__result" href="' + p.url + '">' +
              (p.image ? '<img src="' + p.image + '" alt="" width="56" height="56" loading="lazy">' : '') +
              '<span>' + escapeHtml(p.title) + '</span></a>';
          }).join("");
        });
    }, 250));
  }
  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  /* ---------- Cart drawer ---------- */
  var CartDrawer = {
    el: null,
    init: function () {
      this.el = qs("[data-cart-drawer]");
      if (!this.el) return;
      qsa("[data-cart-open]").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          CartDrawer.open();
        });
      });
      qsa("[data-cart-close]", this.el).forEach(function (btn) {
        btn.addEventListener("click", function () { CartDrawer.close(); });
      });
      qs(".cart-drawer__overlay", this.el).addEventListener("click", function () { CartDrawer.close(); });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") CartDrawer.close();
      });
      this.el.addEventListener("click", function (e) {
        var removeBtn = e.target.closest("[data-cart-remove]");
        if (removeBtn) {
          e.preventDefault();
          CartDrawer.updateLine(removeBtn.getAttribute("data-cart-remove"), 0);
          return;
        }
        var stepBtn = e.target.closest("[data-cart-step]");
        if (stepBtn) {
          e.preventDefault();
          var input = qs('[data-cart-qty="' + stepBtn.getAttribute("data-cart-step-key") + '"]', CartDrawer.el);
          var next = parseInt(input.value, 10) + parseInt(stepBtn.getAttribute("data-cart-step"), 10);
          if (next < 0) next = 0;
          CartDrawer.updateLine(stepBtn.getAttribute("data-cart-step-key"), next);
        }
      });
      this.el.addEventListener("change", function (e) {
        if (e.target.matches("[data-cart-qty]")) {
          CartDrawer.updateLine(e.target.getAttribute("data-cart-qty"), parseInt(e.target.value, 10) || 0);
        }
      });
    },
    open: function () {
      this.render();
      this.el.setAttribute("data-open", "true");
      document.body.style.overflow = "hidden";
    },
    close: function () {
      this.el.setAttribute("data-open", "false");
      document.body.style.overflow = "";
    },
    render: function () {
      fetch("/?section_id=cart-drawer")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-cart-drawer-inner]");
          var current = qs("[data-cart-drawer-inner]", CartDrawer.el);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          CartDrawer.updateBubble();
        });
    },
    updateBubble: function () {
      fetchJSON("/cart.js").then(function (cart) {
        qsa("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
      });
    },
    updateLine: function (key, qty) {
      fetchJSON("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { CartDrawer.render(); });
    },
    add: function (formData) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(formData)
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data.status) { return Promise.reject(data); }
        CartDrawer.open();
        return data;
      });
    }
  };

  function initAddToCartForms() {
    qsa("form[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var submitBtn = qs('[type="submit"]', form);
        var formData = new FormData(form);
        var payload = { items: [{ id: formData.get("id"), quantity: parseInt(formData.get("quantity") || "1", 10) }] };
        if (submitBtn) submitBtn.disabled = true;
        CartDrawer.add(payload).catch(function (err) {
          var errorEl = qs("[data-form-error]", form);
          if (errorEl) errorEl.textContent = (err && err.description) || "Could not add this item to your cart.";
        }).finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
      });
    });
  }

  function initQuickAdd() {
    document.addEventListener("submit", function (e) {
      var form = e.target.closest("[data-quick-add-form]");
      if (!form) return;
      e.preventDefault();
      var variantId = form.querySelector('[name="id"]').value;
      var btn = qs('[type="submit"]', form);
      btn.disabled = true;
      CartDrawer.add({ items: [{ id: variantId, quantity: 1 }] }).catch(function () {
        window.location = form.getAttribute("action");
      }).finally(function () { btn.disabled = false; });
    });
  }

  function initQtySteppers() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-qty-step]");
      if (!btn) return;
      var wrap = btn.closest(".qty-selector");
      var input = qs("input", wrap);
      var next = parseInt(input.value, 10) + parseInt(btn.getAttribute("data-qty-step"), 10);
      input.value = Math.max(1, next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  /* ---------- Accordion ---------- */
  function initAccordions() {
    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-accordion-trigger]");
      if (!trigger) return;
      var item = trigger.closest("[data-accordion-item]");
      var panel = qs("[data-accordion-panel]", item);
      var isOpen = item.getAttribute("data-open") === "true";
      item.setAttribute("data-open", isOpen ? "false" : "true");
      trigger.setAttribute("aria-expanded", isOpen ? "false" : "true");
      panel.style.maxHeight = isOpen ? "0px" : panel.scrollHeight + "px";
    });
  }

  /* ---------- Variant picker (product page) ---------- */
  function initVariantPicker() {
    qsa("[data-product-info]").forEach(function (root) {
      var dataEl = qs("[data-product-json]", root);
      if (!dataEl) return;
      var product = JSON.parse(dataEl.textContent);
      var optionInputs = qsa("[data-option-input]", root);

      function findVariant(selected) {
        return product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }
      function currentSelections() {
        var groups = {};
        optionInputs.forEach(function (input) {
          if (input.type === "radio" && !input.checked) return;
          groups[input.getAttribute("data-option-index")] = input.value;
        });
        return Object.keys(groups).sort().map(function (k) { return groups[k]; });
      }
      function updateUI(variant) {
        var priceEl = qs("[data-product-price]", root);
        var compareEl = qs("[data-product-compare]", root);
        var idInput = qs('[name="id"]', root);
        var submitBtn = qs("[data-add-to-cart]", root);
        var availEl = qs("[data-product-availability]", root);
        if (!variant) {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute("data-unavailable-text") || "Unavailable"; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = window.Shopify.formatMoney(variant.price, root.getAttribute("data-money-format"));
        if (compareEl) {
          if (variant.compare_at_price > variant.price) {
            compareEl.textContent = window.Shopify.formatMoney(variant.compare_at_price, root.getAttribute("data-money-format"));
            compareEl.hidden = false;
          } else { compareEl.hidden = true; }
        }
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available
            ? (submitBtn.getAttribute("data-add-text") || "Add to cart")
            : (submitBtn.getAttribute("data-unavailable-text") || "Sold out");
        }
        if (availEl) availEl.textContent = variant.available ? "In stock, ready to ship" : "Currently unavailable";
        if (variant.featured_media) {
          var mainImg = qs("[data-gallery-main] img", root.closest("[data-product-section]") || document);
          var thumb = qs('[data-gallery-thumb="' + variant.featured_media.id + '"]', root.closest("[data-product-section]") || document);
          if (mainImg && variant.featured_media.preview_image) mainImg.src = variant.featured_media.preview_image.src.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, "_800x$1$2");
          if (thumb) thumb.click();
        }
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      }
      optionInputs.forEach(function (input) {
        input.addEventListener("change", function () {
          updateUI(findVariant(currentSelections()));
        });
      });
    });
  }

  /* ---------- Gallery thumbs ---------- */
  function initGallery() {
    qsa("[data-gallery]").forEach(function (gallery) {
      var main = qs("[data-gallery-main] img", gallery);
      qsa("[data-gallery-thumb]", gallery).forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          qsa("[data-gallery-thumb]", gallery).forEach(function (t) { t.setAttribute("aria-current", "false"); });
          thumb.setAttribute("aria-current", "true");
          if (main && thumb.getAttribute("data-full")) main.src = thumb.getAttribute("data-full");
        });
      });
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var Wishlist = {
    key: "bhaktibox_wishlist",
    get: function () {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; }
    },
    save: function (list) {
      try { localStorage.setItem(this.key, JSON.stringify(list)); } catch (e) {}
    },
    toggle: function (id) {
      var list = this.get();
      var idx = list.indexOf(id);
      if (idx > -1) { list.splice(idx, 1); } else { list.push(id); }
      this.save(list);
      return list.indexOf(id) > -1;
    },
    init: function () {
      var list = this.get();
      qsa("[data-wishlist-toggle]").forEach(function (btn) {
        var id = btn.getAttribute("data-wishlist-toggle");
        btn.setAttribute("aria-pressed", list.indexOf(id) > -1 ? "true" : "false");
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          var pressed = Wishlist.toggle(id);
          btn.setAttribute("aria-pressed", pressed ? "true" : "false");
        });
      });
    }
  };

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    var container = qs("[data-recommendations]");
    if (!container || !container.getAttribute("data-url")) return;
    fetch(container.getAttribute("data-url"))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-recommendations]");
        if (fresh && fresh.innerHTML.trim()) container.innerHTML = fresh.innerHTML;
      });
  }

  /* ---------- Init ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    initScrollReveal();
    initMobileNav();
    initSearch();
    CartDrawer.init();
    initAddToCartForms();
    initQuickAdd();
    initQtySteppers();
    initAccordions();
    initVariantPicker();
    initGallery();
    Wishlist.init();
    initRecommendations();
  });
})();
